module.exports = __webpack_public_path__ + "static/media/hard_dollars_5.4791ae3a.png";